import { Logger } from 'common/logger';
import { JOB_WEATHER_HISTORY_INTERVAL } from 'common/constants';
import { WEATHER_DEFAULT_STATE, transformForecast, transformHistorical, transformLightningRisk } from './weather.utils';
import { checkWebsocketConnection } from 'common/saga-utils';
import { rematchStore } from 'models/rematchStore';

const weather = {
    name: 'weather',
    state: { ...WEATHER_DEFAULT_STATE },
    effects: (dispatch) => ({
        async requestHistory() {
            await checkWebsocketConnection();

            const startPolling = () => {
                const state = rematchStore.getState();
                const id = state.weather.data?.id;
                const { connected } = state.webSocket;

                if (connected) {
                    dispatch({
                        type: 'webSocket/requestWeatherHistory',
                        payload: {
                            entityKey: id,
                            precision: 'minute',
                            count: 60,
                        },
                    });
                }
            };
            startPolling();
            // Start the polling
            const polling = setInterval(startPolling, JOB_WEATHER_HISTORY_INTERVAL);
            dispatch.weather.setPolling(polling);
        },
        clearHistoryJobs() {
            Logger.info('Stopping history job');
            dispatch.weather.clearPolling(); // Clear polling when this action is dispatched
        },

        async setActive() {
            dispatch.weather.isActive({ isActive: true });
        },

        async setInactive() {
            dispatch.weather.isActive({ isActive: false });
        },

        async reset() {
            Logger.info('Reset weather');
            dispatch.weather.resetState();
            dispatch.weather.requestHistory();
        },

        async loadHistory(payload) {
            dispatch.weather.setHistoricalData(payload);
            dispatch.weather.setTemperatureData(payload);
        },
    }),

    reducers: {
        isActive(state, payload) {
            return {
                ...state,
                component: {
                    ...state.component,
                    isActive: payload.isActive,
                },
            };
        },

        resetState(state) {
            Logger.debug('Reset weather state');
            return {
                ...state,
                data: WEATHER_DEFAULT_STATE.data,
                historical: WEATHER_DEFAULT_STATE.historical,
                forecast: WEATHER_DEFAULT_STATE.forecast,
                polling: null,
            };
        },

        load(state, payload) {
            Logger.info('Weather data updated.', payload);
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload,
                },
            };
        },

        setHistoricalData(state, payload) {
            Logger.info('Weather history updated.', payload);
            return {
                ...state,
                historical: transformHistorical(state.data, payload),
            };
        },

        setTemperatureData(state, payload) {
            return {
                ...state,
                temperature: {
                    ...state.temperature,
                    air: payload.values.ambient_temperature,
                    water: payload.values.water_temperature,
                },
            };
        },

        loadForecast(state, payload) {
            Logger.info('Weather forecast updated.', payload);
            return {
                ...state,
                forecast: transformForecast(state.data, payload),
                lightningRisk: transformLightningRisk(payload),
            };
        },
        clearPolling(state) {
            if (state.polling) {
                clearInterval(state.polling);
                Logger.info('Polling stopped'); // Log when polling is stopped
            }
            return { ...state, polling: null };
        },
        setPolling(state, polling) {
            return { ...state, polling };
        },
    },
};

export default weather;
